export const QUERY_GET_SUBMITTAL_COLUMN_CONFIG = `
  GetSavedSubmittalColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      submittal_column_config
    }
  }
`;
